import * as angular from 'angular';
import { Growl } from 'angular/custom/services/growl.service';
import { NetworkPointResource } from 'app/_resources/network-point.resource';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { FileService } from 'app/_services/file.service';

class NetworkPointDetailsOperatorInfoCtrl implements ng.IController {
    public networkPointId: number;
    public networkPoint: NetworkPointDto;
    private chargesDto: ChargesDto;
    public isCreateMode: boolean;
    public isEditMode: boolean = this.isCreateMode && !!this.networkPointId;
    public loggedInUser: LoginResult;
    public usesCapacityManagement: boolean;
    public eicCheckbox: boolean = false;

    public uploadSuccessful: boolean = false;
    public uploadError: boolean = false;
    public uploadErrorMessage: string;
    public responseXml: string;
    public form: any;

    constructor(
        private fileService: FileService,
        private NetworkPoint: NetworkPointResource,
        private growl: Growl,
        private errorHandler: ErrorHandler,
        private $location: ng.ILocationService,
        public DATES
    ) {}

    $onInit(): void {
        if (
            this.isEditMode &&
            this.loggedInUser.tsoName != this.networkPoint.tso0Name
        ) {
            this.isEditMode = false;
            this.isCreateMode = false;
        }

        if (this.isCreateMode && !this.isEditMode) {
            this.networkPoint = <NetworkPointDto>{};
            this.networkPoint.validity0 = <Interval>{};
            this.networkPoint.authorityCode0 = 'EIC';
            this.networkPoint.floatingTariff0 = true;
            this.networkPoint.active0 = true;
        }
    }

    public createNetworkPoint(): void {
        const networkPointDto = this.removeEicFieldIfNullOrEmpty(
            this.networkPoint
        );

        this.NetworkPoint.save(
            { networkPointDtos: [networkPointDto] },
            (res) => {
                this.uploadSuccessful = true;
                this.growl.show(
                    `${this.isEditMode ? 'Update' : 'Upload'} successful`,
                    'success'
                );
                this.responseXml = res.responseXml;
            },
            (error) => {
                if (
                    error &&
                    error.data &&
                    error.data.description &&
                    error.data.description ==
                        'CONNECTIONPOINT_IS_PART_OF_BUNDLE'
                ) {
                    this.growl.show(error.data.message, 'danger');
                } else {
                    this.errorHandler(error);
                }
            }
        );
    }

    private removeEicFieldIfNullOrEmpty(
        networkPoint: NetworkPointDto
    ): NetworkPointDto {
        if (networkPoint.acerEic === null || networkPoint.acerEic === '') {
            delete networkPoint.acerEic;
        }
        return networkPoint;
    }

    public downloadXml(form: ng.IFormController) {
        if (form.$valid && this.eicCheckbox) {
            this.removeEmptyFields();
            this.NetworkPoint.generateXml(
                { networkPointDtos: [this.networkPoint] },
                (res) => {
                    this.fileService.triggerFileDownload(
                        res.responseXml,
                        'network-point.xml',
                        'text/xml'
                    );
                },
                this.errorHandler
            );
        } else {
            this.form.$submitted = true;
            this.submit(form);
        }
    }

    public downloadResponse(): void {
        if (this.uploadSuccessful) {
            this.fileService.triggerFileDownload(
                this.responseXml,
                'network-point-response.xml',
                'text/xml'
            );
        }
    }

    //Remove fields from JSON that are not filled
    public removeEmptyFields(): void {
        if (this.networkPoint.chargesDto) {
            this.chargesDto = this.networkPoint.chargesDto;

            if (
                this.chargesDto.measurementCharge0 != null &&
                this.chargesDto.measurementCharge0.originalValue.value == null
            ) {
                delete this.networkPoint.chargesDto.measurementCharge0;
            }
            if (
                this.chargesDto.biogasCharge0 != null &&
                this.chargesDto.biogasCharge0.originalValue.value == null
            ) {
                delete this.networkPoint.chargesDto.biogasCharge0;
            }
            if (
                this.chargesDto.balancingCharge0 != null &&
                this.chargesDto.balancingCharge0.originalValue.value == null
            ) {
                delete this.networkPoint.chargesDto.balancingCharge0;
            }
            if (
                this.chargesDto.commodityFee0 != null &&
                this.chargesDto.commodityFee0.originalValue.value == null
            ) {
                delete this.networkPoint.chargesDto.commodityFee0;
            }
            if (
                this.chargesDto.operatingCharge0 != null &&
                this.chargesDto.operatingCharge0.originalValue.value == null
            ) {
                delete this.networkPoint.chargesDto.operatingCharge0;
            }
            if (
                this.chargesDto.accountingCharge0 != null &&
                this.chargesDto.accountingCharge0.originalValue.value == null
            ) {
                delete this.networkPoint.chargesDto.accountingCharge0;
            }
            if (
                this.chargesDto.gasQualityConversionCharge0 != null &&
                this.chargesDto.gasQualityConversionCharge0.originalValue
                    .value == null
            ) {
                delete this.networkPoint.chargesDto.gasQualityConversionCharge0;
            }
        }
    }

    public submit(form: ng.IFormController): boolean {
        if (!form.$valid || !this.eicCheckbox) {
            this.growl.show(
                '<strong>Validation error</strong><br/>Please check all mandatory fields.',
                'danger',
                { allowHtml: true }
            );
            return false;
        }
        this.removeEmptyFields();
        this.createNetworkPoint();
        return true;
    }

    createBundle(networkPoint) {
        this.$location
            .path('/network-point/bundle/create')
            .search('nwp', networkPoint.id);
    }

    changeVersion(version: VersionDto): void {
        this.$location.search('version', version);
    }

    changesEffectiveAt(): Date {
        return moment(this.networkPoint.validity0.start)
            .startOf('day')
            .isAfter(moment(Date.now()).startOf('day'))
            ? moment(this.networkPoint.validity0.start).toDate()
            : moment(Date.now()).toDate();
    }
}

angular.module('app').component('pkpNetworkPointDetailsOperatorInfo', {
    controller: NetworkPointDetailsOperatorInfoCtrl,
    template:
        require('app/network-point/network-point-details-operator-info.component.html'),
    bindings: {
        networkPointId: '<',
        networkPoint: '<',
        loggedInUser: '<',
        isCreateMode: '=',
        usesCapacityManagement: '='
    }
});
